import {RevolveFeatureDefinitionModel} from '../../../feature/definition/revolve/RevolveFeatureDefinition';
import {RevolveFeaturePrototype} from '../../../feature/prototype/revolve/RevolveFeaturePrototype';
import {BossRevolvePreviewObject} from '../revolve/BossRevolvePreviewObject';
import {BossRevolveResultObject} from '../revolve/BossRevolveResultObject';
import {FeatureMeshObjectFactory, type FeatureMeshObjectBuildInput} from './FeatureMeshObjectFactory';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/factory 目录；
 * 2. 负责创建旋转特征专属预览体与结果体对象；
 * 3. 该工厂让 MeshManager 能按 revolve prototype 命中对象化结果链。
 */

/**
 * 旋转特征 mesh 对象工厂。
 */
export class BossRevolveMeshObjectFactory extends FeatureMeshObjectFactory {
    /**
     * @inheritdoc
     */
    public create(input: FeatureMeshObjectBuildInput) {
        if (input.isPreview) {
            if (
                input.context?.prototype instanceof RevolveFeaturePrototype
                && input.context.draftDefinition instanceof RevolveFeatureDefinitionModel
            ) {
                return new BossRevolvePreviewObject({
                    prototype: input.context.prototype,
                    draftDefinition: input.context.draftDefinition,
                    meshData: input.meshData,
                    geometry: input.geometry,
                    material: input.material,
                });
            }
            return null;
        }
        if (input.context?.prototype instanceof RevolveFeaturePrototype) {
            return new BossRevolveResultObject({
                prototype: input.context.prototype,
                meshData: input.meshData,
                geometry: input.geometry,
                material: input.material,
            });
        }
        return null;
    }
}
